import img1 from "./images/rocketSlide1.png";
import img2 from "./images/rocketSlide2.png";
//  import wealthCreation from '../images/wealth-creation.png';
// import investor from '../images/investor.png';

// import owl
// import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

import { Carousel } from "react-bootstrap";

import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Home = () => {
  return (
    <div>
      <Navbar />
      <section className="mt-5">
        <Carousel>
          <Carousel.Item>
            {/* <img
              className="d-block w-100"
              src={img1}
              alt="First slide"
            /> */}
            <div className="background1">
              <div className="container pt-5">
                <div className="row">
                  <div className="col-xs-12 col-md-6 py-5">
                    <h4 className="bold text-white pt-4">
                      Invest Smarter, earn better <br /> with the Nörrenberger{" "}
                      <br />
                      Turbo Fund
                    </h4>
                    <p className="small text-white">
                      <br />
                      Your gateway to boosting your income and achieving your
                      financial goals
                    </p>
                    <br />
                    <div className="d-flex">
                      <div>
                        <Link to="/registration">
                          <button className="btn-custom me-2">
                            <i className="bi bi-person-add"></i> Open an Individual Account
                          </button>
                        </Link>
                      </div>
                      <div>
                      <Link to="/corporate-registration">
                          <button className="btn-custom me-2">
                            <i className="bi bi-person-add"></i> Open a Corporate Account
                          </button>
                        </Link>
                      </div>
                    </div>
                    <Link to="/fund-account">
                    <button className="btn-custom-outline my-3">
                  
                 
                        I already have an account<i class="fa fa-location-arrow" aria-hidden="true">⮕</i>
                
                    </button>
                    </Link>
                  </div>
                  <div className="col-xs-12 col-md-6">
                    <img src={img1} className="hero-img mt-3" alt="" />
                  </div>
                </div>
              </div>
              <br />
              <br />
              <br />
            </div>
            <Carousel.Caption></Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <div className="background2">
              <div className="container pt-5">
                <div className="row">
                  <div className="col-xs-12 col-md-6 py-5">
                    <br />
                    <br />
                    <br />
                    <h4 className="bold text-white">
                      Improve your <br />
                      Portfolio Mix
                    </h4>
                    <p className="small text-white">
                      By Investing in diversified portfolio of largely fixed
                      income instruments
                    </p>

                    <div className="d-flex mt-4">
                      <div>
                        <Link to="/registration">
                          <button className="btn-custom me-2">
                            <i className="bi bi-person-add"></i>Open an Individual Account
                          </button>
                        </Link>
                      </div>
                      <div>
                        <Link to="/corporate-registration">
                          <button className="btn-custom me-2">
                            <i className="bi bi-person-add"></i> Open a Corporate Account
                          </button>
                        </Link>
                      </div>
                    </div>
                    <Link to="/fund-account">
                    <button className="btn-custom-outline my-3">
                  
                 
                        I already have an account<i class="fa fa-location-arrow" aria-hidden="true">⮕</i>
                
                    </button>
                    </Link>
                  </div>
                  <div className="col-xs-12 col-md-6 pt-5">
                    <img src={img2} className="hero-img" alt="" />
                  </div>
                </div>
              </div>
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>

            <Carousel.Caption></Carousel.Caption>
          </Carousel.Item>
        </Carousel>

        {/* </OwlCarousel> */}
      </section>
      <Footer/>
    </div>
  );
};

export default Home;
